module.exports = __webpack_public_path__ + "img/timgNoe.8545543d.jpg";